export default {
  beforeCreate(context, inject, vueOptions) {
    const { i18n, store } = vueOptions
    context.$i18n = store.$i18n = i18n
  },
}
